import { TFilters } from './types';
import moment, { Moment } from 'moment';

export function formatarObjRetorno(obj: any) {
    const copy = { ...obj };
    for (let prop in copy) {
        if (copy[prop] === null || copy[prop] === "" || copy[prop] === undefined) {
            delete copy[prop];
            continue;
        }

        // Limpar o nome da propriedade para verificação de sufixos
        // Remove tudo entre o último ponto e o underscore do sufixo
        const cleanProp = prop.includes('.') ? 
        prop.replace(/\.[^._]+(?=_[^.]+$)/, '') : 
        prop;

        // Processar o valor conforme o tipo de propriedade
        if (cleanProp.includes('_maior_igual') || cleanProp.includes('_menor_igual')) {
            const num = Number(copy[prop]);
            if (!isNaN(num)) {
                copy[prop] = num;
            }
        }

        if ((cleanProp.includes('_inicio') || cleanProp.includes('_fim')) && moment.isMoment(copy[prop])) {
            copy[prop] = copy[prop].format("YYYY-MM-DD");
        }

        if (cleanProp.includes('_contem') && typeof copy[prop] === 'string') {
            copy[prop] = copy[prop].split(',').filter((item: string) => item.trim() !== '');
        }

        // Se a propriedade limpa for diferente da original, substituir no objeto
        if (cleanProp !== prop) {
            copy[cleanProp] = copy[prop];
            delete copy[prop];
        }
    }
    return copy;
}


export const cleanDynFilter = (headId: string, headType: string) => {
    const obj: any = {}
    if (headType === "date") {
        obj[`${headId}_inicio`] = null;
        obj[`${headId}_fim`] = null;
    }

    if (headType === "number" || headType === "monetary") {
        obj[`${headId}_maior_igual`] = null;
        obj[`${headId}_menor_igual`] = null;
    }

    if (headType === "string" || headType === "text") {
        obj[`${headId}_pesquisar`] = ""
        obj[`${headId}_contem`] = []
    };

    return obj;
}

export function pegarItemPeloPrefixo(obj: any, prefix: string) {
    return Object.fromEntries(
        Object.entries(obj).filter(([key]) => key.startsWith(prefix))
    );
}

export const processUrlFilters = (preFilters: TFilters, urlParams: URLSearchParams): TFilters => {
    // Se já existem filtros preenchidos, retorna eles
    if (Object.keys(preFilters).length > 0) {
        return preFilters;
    }

    // Se não há parâmetros na URL, retorna objeto vazio
    if (urlParams.size === 0) {
        return {};
    }

    const newFilters: Record<string, string | Moment | null | string[]> = {};

    urlParams.forEach((value, key) => {
        // Ignora valores vazios ou nulos
        if (value === null || 
            value === "" || 
            value === "null" || 
            value === 'undefined' || 
            value === undefined ||
            (Array.isArray(value) && value.length === 0)
        ) {
            newFilters[key] = '';
            return;
        }

        // Processa datas
        if ((key.includes("_inicio") || key.includes("_fim")) && value) {
            newFilters[key] = moment(value, "YYYY-MM-DD", true);
        }
        // Processa arrays (contém)
        else if (key.includes("_contem") || key.includes("_naocontem")) {
            newFilters[key] = value.split(",");
        }
        // Outros valores
        else {
            newFilters[key] = value;
        }
    });

    return newFilters;
};

export const processFilterValues = (
    values: TFilters,
    clearSingleParam: (key: string) => void
): Record<string, any> => {
    const filteredValues: Record<string, any> = {};
    
    Object.entries(values).forEach(([key, value]) => {
        if (isEmptyValue(value)) {
            clearSingleParam(key);
            return;
        }
        
        filteredValues[key] = formatFilterValue(value);
    });
    
    return filteredValues;
};

const isEmptyValue = (value: any): boolean => {
    return value === null || 
           value === "" || 
           (Array.isArray(value) && value.length === 0) || 
           value === "null" || 
           value === 'undefined' || 
           value === undefined ||
           Number.isNaN(value);
};

const formatFilterValue = (value: any): any => {
    if (moment.isMoment(value)) {
        return value.format("YYYY-MM-DD");
    }
    return value;
};